module.exports = "/images/Homepage-Workflow Diagram.jpg";